/* Nilo V5.13.49 — home and price display guards. Observation only; no cart / COD changes. */
(function(){'use strict';if(window.__nilo51349Guard)return;window.__nilo51349Guard=true;
 var onHome=!!document.querySelector('[data-nilo-app-home]');
 function cards(scope){return Array.prototype.slice.call(scope.querySelectorAll('.nilo-product-card'));}
 function family(card){var str=card.dataset.niloFamily||card.dataset.niloTitle||(card.querySelector('.nilo-product-card__title')||{}).textContent||'';
   return String(str).normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^\p{L}\p{N}]+/gu,' ').trim();}
 function cents(card){return Number(card.dataset.niloPrice||'0');}
 function priceConflict(){var groups=Object.create(null);
  cards(document).forEach(function(card){var f=family(card),p=cents(card),c=Number(card.dataset.niloCompare||0);
   if(!f||!p||!c)return;var key=f+'|'+p;if(!groups[key])groups[key]={prices:new Set(),cards:[]};groups[key].prices.add(c);groups[key].cards.push(card);
  });
  Object.keys(groups).forEach(function(key){var g=groups[key];if(g.prices.size<2)return;
   g.cards.forEach(function(card){card.dataset.niloPriceConflict='1';});
  });
 }
 function strictPrice(){if(!onHome)return;
  var specs=[['under140',14000],['under200',20000],['under250',25000],['under300',30000]];
  specs.forEach(function(spec){
   var nodes=document.querySelectorAll('[data-nilo-smart-mode="'+spec[0]+'"],[data-nilo-home-zone="'+spec[0]+'"],[data-nilo-section-mode="'+spec[0]+'"]');
   Array.prototype.forEach.call(nodes,function(section){cards(section).forEach(function(card){
    var price=cents(card);if(price>=spec[1]||price<=0){card.dataset.niloPriceOutOfRange='1';card.hidden=true;}
   });});
  });
  // Catch editorial blocks with a literal heading 'Moins de 200 DH'.
  document.querySelectorAll('[data-nilo-smart-section],.nilo-app-section').forEach(function(section){
   var heading=section.querySelector('h2');if(!heading)return;
   var match=(heading.textContent||'').match(/moins de (140|200|250|300)\s*(?:dh|dirhams)/i);
   if(!match)return;var ceiling=Number(match[1])*100;
   cards(section).forEach(function(card){var p=cents(card);if(!p||p>=ceiling){card.dataset.niloPriceOutOfRange='1';card.hidden=true;}});
  });
 }
 function dedupeHome(){
  if(!onHome||document.querySelector('[data-nilo-app-home]')?.dataset.niloV512Rotated!=='1')return;
  var seen=new Set();
  /* V5.13.85: the paginated catalogue is not a small editorial rail.
     Global family deduplication on this infinite grid previously hid most
     cards in each subsequent Shopify page, leaving empty editorial panels.
     Keep deduplication for curated rails only; catalogue handles are already
     deduplicated by the infinite-feed controller. */
  var rails=document.querySelectorAll('[data-nilo-personal-rail],[data-nilo-home-zone],[data-nilo-smart-rail],[data-nilo-v511-home-endless]');
  Array.prototype.forEach.call(rails,function(rail){
   if(rail.closest('[hidden]'))return;
   var list=cards(rail).filter(function(card){return !card.hidden&&!card.closest('.nilo-smart-item[hidden]');});
   // Keep at least two visible distinct models in each editorial rail.
   var uniqueRemain=list.length;
   list.forEach(function(card){
    var f=family(card);if(!f)return;
    if(seen.has(f)&&uniqueRemain>2){
     var item=card.closest('.nilo-smart-item')||card;
     item.hidden=true;item.dataset.niloDuplicateHome='1';uniqueRemain--;
    }else seen.add(f);
   });
  });
 }
 function run(){priceConflict();strictPrice();dedupeHome();}
 var timer=null;function schedule(){if(timer)return;timer=setTimeout(function(){timer=null;run();},250);}
 window.addEventListener('nilo:home-catalogue-ready',schedule);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){run();start();},{once:true});else{run();start();}
 function start(){var observer=new MutationObserver(schedule);var root=document.querySelector('main')||document.body;
  observer.observe(root,{childList:true,subtree:true});
 }
})();
